import { useMemo, useState } from "react";
import classNames from "classnames";

import Progress from "@/common/Progress";
import StickyButton from "@/common/StickyButton";
import { QuestionTypes } from "@/constants/questionsIds";
import femaleJeansImg from "@/female/assets/reviews/weight-loss-user-jeans.webp";
import maleJeansImg from "@/male/assets/reviews/weight-loss-user-jeans.webp";
import { QuestionComponentProps } from "@/types/common";
import { useGender } from "@/utils/GenderProvider";

import { reviews } from "./utils";

const ReviewWithLoader = ({
    handleNext,
    isActive,
}: QuestionComponentProps<QuestionTypes.ReviewWithLoader>) => {
    const { isFemale } = useGender();
    const [isProgressLoaded, setIsProgressLoaded] = useState(false);

    const { title, name, quote, userImg } = useMemo(
        () => (isFemale ? reviews.female : reviews.male),
        [isFemale]
    );

    return (
        <div className="flex h-full flex-col justify-between text-white female:text-black">
            <div>
                <div className="mb-6 text-zing-24-32 font-semibold">{title}</div>
                <div className="mb-4 flex items-end gap-4">
                    <img src={userImg} className="max-w-10" />
                    <div>
                        <div>{`"${quote}"`}</div>
                        <div className="mt-2 text-zing-12-14 text-zing-neutral-cool-grey-400">{`— ${name}`}</div>
                    </div>
                </div>
                <img src={isFemale ? femaleJeansImg : maleJeansImg} />
            </div>
            <div className={classNames("pb-6 md:pb-10", { hidden: isProgressLoaded })}>
                <div className="after:content[''] pb-1 text-center text-zing-12-18 after:ml-2 after:inline-block after:h-[10px] after:w-[10px] after:animate-spin after:rounded-[50%] after:border-[1px] after:border-l-[transparent] female:after:border-black female:after:border-l-[transparent]">
                    Analysing responses
                </div>
                <Progress
                    runProgress={isActive}
                    onLoaded={() => {
                        setIsProgressLoaded(true);
                    }}
                    className="female:bg-opacity-1 *:female:text-black"
                />
            </div>
            {isProgressLoaded && <StickyButton onClick={() => handleNext()} />}
        </div>
    );
};

export default ReviewWithLoader;
